import React from 'react'
import { Box, Text } from 'grommet'

import useMoodUser from 'hooks/useMoodUser'
import { useTranslation } from 'react-i18next'

export default function PlotAsBox() {
  const { name } = useMoodUser()
  const { t } = useTranslation()
  return (
    <Box pad="xsmall">
      <Text color="gray" size="xsmall" textAlign="end">
        {t('basic.plot-as')} {name}
      </Text>
    </Box>
  )
}
